// extracted by mini-css-extract-plugin
export default {"container":"_20908f774f07fa83"};